<template>
  <panel title="Preço único">
    <form-group label="Utilizar preço único">
      <label class="form-switch">
        <input type="checkbox" v-model="useUniquePrice">
        <span class="form-switch__indicator"></span>
      </label>
      <small class="form-help">Define se será utilizado preço único para todas variações.</small>
    </form-group>

    <product-price-unique v-if="price && useUniquePrice" :input="price" :module="fromModule || product.source" :sku="product.variations[0].sku"/>
  </panel>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import ProductPriceUnique from '@/components/shared/ProductPriceUnique'

  export default {
    data: () => ({
      price: null,
      useUniquePrice: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: false,
        default: null
      }
    },
    mounted () {
      this.price = cloneDeep(this.product.variations[0].price)
      this.updateIfProductUseUniquePrice(this.product)
      this.updatePriceByProductId({ productId: this.product.productId, price: this.price })

      this.useUniquePrice = this.isUseUniquePrice(this.product.productId)
    },
    methods: {
      ...mapActions('editPrices', [
        'updateIfProductUseUniquePrice',
        'updatePriceByProductId',
        'removeProduct',
        'addProduct'
      ])
    },
    computed: {
      ...mapGetters('editPrices', [
        'isUseUniquePrice'
      ])
    },
    watch: {
      useUniquePrice (value) {
        if (value) {
          this.addProduct(this.product)
          return
        }

        this.removeProduct(this.product)
      }
    },
    components: {
      Panel,
      FormGroup,
      ProductPriceUnique
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductEditBulkPrice.vue?0bc7e063